<template>
  <div style="width: 92%; margin: 0 auto; padding-top: 45px">
    <Header title="任务执行" />
    <div class="btitle">
      工程信息
      <el-tag size="small" style="
          float: right;
          margin-top: 6px;
          margin-right: 10px;
          background: #fff;
        " :type="getStateColor(data.state)">{{ getStateText(data.state) }}</el-tag>
    </div>
    <div class="item">
      <label class="lft">任务编号：</label>
      <label class="cnt">{{ data.taskno }}</label>
    </div>
    <div class="item">
      <label class="lft">任务派发单位：</label>
      <label class="cnt">{{ data.test_company }}</label>
    </div>
    <div class="item">
      <label class="lft">工程名称：</label>
      <label class="cnt">{{ data.enginner_name }}</label>
    </div>
    <div class="item">
      <label class="lft">检测项目：</label>
      <label class="cnt">{{ data.test_item }}</label>
    </div>
    <div class="item">
      <label class="lft">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</label>
      <label class="cnt">{{ data.customer }}</label>
    </div>
    <div class="item">
      <label class="lft">联系电话：</label>
      <label class="cnt">{{ data.customer_mobile }}</label>
    </div>

    <div class="item">
      <label class="lft">级别：</label>
      <label class="cnt">{{ data.jibie }}</label>
    </div>
    <div class="item">
      <label class="lft">是否签订合同：</label>
      <label class="cnt">{{
        data.is_qiandinghetong == "true" ? "是" : "否"
      }}</label>
    </div>
    <div class="item">
      <label class="lft">合同编号：</label>
      <label class="cnt">{{ data.hetongbianhao }}</label>
    </div>
    <div class="item">
      <label class="lft">内容及要求：</label>
      <label class="cnt">{{ data.neirongyaoqiu }}</label>
    </div>
    <div class="item">
      <label class="lft">是否需要现场收费：</label>
      <label class="cnt">{{ data.is_shoufei == "true" ? "是" : "否" }}</label>
    </div>

    <div class="item">
      <label class="lft">费用情况：</label>
      <label class="cnt">{{ data.expenses }}</label>
    </div>
    <div class="item">
      <label class="lft">付款方式：</label>
      <label class="cnt">{{ data.paytype }}</label>
    </div>
    <div class="item">
      <label class="lft">需出具报告日期：</label>
      <label class="cnt">{{ data.report_date }}</label>
    </div>
    <div class="item">
      <label class="lft">要求进场时间：</label>
      <label class="cnt">{{ data.require_in_date }}</label>
    </div>
    <div class="item">
      <label class="lft">所在地区：</label>
      <label class="cnt">{{ data.province }} {{ data.city }} {{ data.area }}</label>
    </div>
    <div class="item">
      <label class="lft">详细地址：</label>
      <label class="cnt">{{ data.address }}</label>
    </div>
    <div class="item">
      <label class="lft">业务经理：</label>
      <label class="cnt">{{ data.business_name }}</label>
    </div>
    <div class="item">
      <label class="lft">携带设备：</label>
      <label class="cnt">
        <el-tag style="margin-right: 10px; margin-bottom: 5px" v-for="item in data.deivcelist">{{ item.name }}({{
          item.no }})</el-tag>
      </label>
    </div>
    <div class="btitle">外派记录</div>
    <div class="item">
      <table class="tb">
        <tr>
          <th>日期</th>
          <th>组长</th>
          <th>组员</th>
          <th>车辆</th>
          <th>司机</th>
        </tr>
        <tr v-for="item in data.sublist">
          <td>{{ item.gotime }}</td>
          <td>{{ item.groupleader }}</td>
          <td>
            {{ item.groupusers.join("、") }}
          </td>
          <td>{{ item.carno }}</td>
          <td>{{ item.driver }}</td>
        </tr>
      </table>
    </div>

    <div class="btitle">检测信息上传</div>
    <div class="item">
      <label class="lft">签到时间：</label>
      <label class="cnt">{{
        data.sign_time == null ? "请上传进场照片打卡" : data.sign_time
      }}</label>
    </div>
    <div class="item" style="
        justify-content: space-between;
        margin-bottom: 10px;
        margin-top: 10px;
      ">
      <label class="lft">进场照片：</label>
      <div class="cnt" style="text-align: right">
        <el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
          :on-success="handleUploadSuccess1" :before-upload="beforeAvatarUpload"
          :disabled="data.state != 4 && data.state != 5">
          <img v-if="data.img_1" :src="data.img_1" :preview-src-list="srcList" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>
    <div class="item" style="justify-content: space-between; margin-bottom: 10px">
      <label class="lft">检测照片：</label>
      <div class="cnt" style="text-align: right">
        <el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
          :on-success="handleUploadSuccess2" :before-upload="beforeAvatarUpload"
          :disabled="data.state != 4 && data.state != 5">
          <img v-if="data.img_2" :src="data.img_2" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>
    <div class="item" style="justify-content: space-between; margin-bottom: 30px">
      <label class="lft">离场照片：</label>
      <div class="cnt" style="text-align: right">
        <el-upload class="avatar-uploader" :action="uploadFileUrl" :show-file-list="false"
          :on-success="handleUploadSuccess3" :before-upload="beforeAvatarUpload"
          :disabled="data.state != 4 && data.state != 5">
          <img v-if="data.img_3" :src="data.img_3" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
    </div>

    <div v-if="data.state == 6" style="padding-bottom: 50px; display: flex; justify-content: space-around">
      <el-button v-if="data.state == 6" type="primary" style="width: 80%"
        @click.stop="showCommonQrcode(data.id)">评价二维码</el-button>
    </div>

    <div v-if="data.state == 5" style="padding-bottom: 50px; display: flex; justify-content: space-around">
      <el-button :disabled="data.state != 5" type="primary" style="width: 40%" @click="compeleteTask()">完成检测</el-button>
      <el-button type="danger" :disabled="data.state != 5" style="width: 40%" @click="reTest()">明日再来</el-button>
    </div>
    <div>&nbsp;</div>

    <el-dialog title="评价二维码" :visible.sync="dialog.commentQrcode" :close-on-click-modal="false" width="90%">
      <TaskCommentQrcode ref="taskCommentQrcode" @onSuccess="dialog.commentQrcode = false"></TaskCommentQrcode>
    </el-dialog>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import TaskCommentQrcode from "@/views/dialog/task_commentqrcode.vue";
export default {
  name: "task_add",
  components: { Header, TaskCommentQrcode },
  data() {
    var url = this.$api.ServerURL + "/file.ashx";

    return {
      uploadFileUrl: url,
      dialogReTest: false,
      data: {},
      srcList: [],
      statelist: [
        { id: 1, text: "待审核" },
        { id: 2, text: "待分配" },
        { id: 3, text: "待派车" },
        { id: 4, text: "待检测" },
        { id: 5, text: "检测中" },
        { id: 6, text: "已完成，待评价" },
        { id: 7, text: "已评价" },
      ],
      dialog: { commentQrcode: false },
    };
  },
  mounted() {
    var id = this.$route.query.id;
    this.data.id = id;
    this.showInfo();
  },
  methods: {
    async showInfo() {
      this.data = await this.$api.request.get("/task/get", {
        params: {
          id: this.data.id,
        },
      });
      if (this.data.img_1) {
        this.srcList.push(this.data.img_1);
      }
      if (this.data.img_2) {
        this.srcList.push(this.data.img_2);
      }
      if (this.data.img_3) {
        this.srcList.push(this.data.img_3);
      }
    },
    async compeleteTask() {
      await this.$api.confirm("确认完成检测吗？");
      var data = await this.$api.request.post("/task/compelete", {
        taskid: this.data.id,
      });
      this.$api.success("操作成功");
      this.showInfo();
    },
    showTomorrowBack() {
      this.dialogReTest = true;
    },
    async reTest() {
      await this.$api.confirm("确认再来一次吗？");
      var data = await this.$api.request.post("/task/recheck", {
        taskid: this.data.id,
      });
      this.$api.success("操作成功");
      this.$router.replace("/");
    },
    async handleUploadSuccess1(res, file) {
      this.data.img_1 = res; //URL.createObjectURL(file.raw);
      //异步保存到数据库中，并登记打卡信息
      await this.$api.request.post("/task/signin", {
        taskid: this.data.id,
        img: this.data.img_1,
      });
      this.srcList.push(this.data.img_1);
      this.$message.success("打卡成功");
      this.showInfo();
    },
    async handleUploadSuccess2(res, file) {
      this.data.img_2 = res;
      await this.$api.request.post("/task/uploadimg", {
        taskid: this.data.id,
        type: 2,
        img: this.data.img_2,
      });
      this.srcList.push(this.data.img_2);
      this.$message.success("上传成功");
    },
    async handleUploadSuccess3(res, file) {
      this.data.img_3 = res;
      await this.$api.request.post("/task/uploadimg", {
        taskid: this.data.id,
        type: 3,
        img: this.data.img_3,
      });
      this.srcList.push(this.data.img_3);
      this.$message.success("上传成功");
    },
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }

      return isLt2M;
    },
    showCommonQrcode(id) {
      this.dialog.commentQrcode = true;
      this.$nextTick(() => {
        this.$refs.taskCommentQrcode.showInfo(id);
      });
    },
    getStateText(state) {
      for (var i = 0; i < this.statelist.length; i++) {
        if (this.statelist[i].id == state) {
          return this.statelist[i].text;
        }
      }
    },
    getStateColor(state) {
      switch (state) {
        case 1:
          return "danger";
        case 2:
          return "danger";
        case 3:
          return "danger";
        case 4:
          return "";
        case 5:
          return "";
        case 6:
          return "success";
        case 7:
          return "success";
      }
      return "";
    },
  },
};
</script>
<style scoped>
.item {
  display: flex;
  align-items: center;
  min-height: 40px;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  padding-top: 3px;
  padding-bottom: 3px;
}

.item .lft {
  text-align: left;
  min-width: 80px;
}

.item .cnt {
  text-align: right;
}

.btitle {
  font-size: 17px;
  background: #eee;
  text-align: left;
  line-height: 35px;
  padding-left: 5px;
  margin-top: 20px;
}

.tb {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-left: 1px solid #fff;
  border-top: 1px solid #fff;
}

.tb th,
.tb td {
  font-weight: normal;
  background: #e0f4ff;
  font-size: 13px;
  line-height: 30px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
}

.tb td {
  line-height: 25px;
}

.avatar-uploader {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 78px;
  height: 78px;
  line-height: 78px;
  text-align: center;
}

.avatar {
  width: 78px;
  height: 78px;
  display: block;
}

.filelist {}

.fileitem {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  font-size: 14px;
  line-height: initial;
}

.fileitem a {
  color: #2c3e50;
  text-decoration: none;
  text-align: left;
}
</style>
